/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TunnelStressAreaDto } from '../../models/tunnel-stress-area-dto';

export interface CreateTunnelStressArea$Params {
      body: TunnelStressAreaDto
}

export function createTunnelStressArea(http: HttpClient, rootUrl: string, params: CreateTunnelStressArea$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelStressAreaDto>> {
  const rb = new RequestBuilder(rootUrl, createTunnelStressArea.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TunnelStressAreaDto>;
    })
  );
}

createTunnelStressArea.PATH = '/v1/tunnelstressarea';
